import React, {Component} from 'react';
import Const from 'constants';
import MultiSelect from 'components/atoms/dropdowns/multi-select';
import {sortByProperty} from 'helpers/sorters';

class SelectStackingPlayer extends Component {
    sortedPlayers(players) {
        return players.sort(sortByProperty('salary', 'desc'));
    }
    getOptions() {
        const {players} = this.props;

        return this.sortedPlayers(Object.values(players.all())).map((player) => {
            return {value: player.playerId, label: player.name};
        });
    }
    getSelectedValues(options) {
        return options.filter((option) => inArray(String(option.value), this.props.values)).map((option) => option);
    }
    render() {
        const options = this.getOptions();

        return (
            <MultiSelect
                key={Const.STACK_WITH_PLAYER}
                onSelect={this.props.onChange}
                options={options}
                values={this.getSelectedValues(options)}
                placeholder={'Select player'}
            />
        );
    }
}

export default SelectStackingPlayer;
